import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { BeyondRoutingModule } from './beyond-routing.module';

import { BeyondListComponent } from './beyond-list/beyond-list.component';
import { BeyondCreateComponent } from './beyond-create/beyond-create.component';

@NgModule({
  declarations: [BeyondListComponent, BeyondCreateComponent],
  imports: [
    CommonModule,
    BeyondRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class BeyondModule { }
